import React from "react";
import Slider from "react-slick";

const ProductImageGallery = ({
  images,
  showArrows = true,
  showDots = false,
  infinite = true,
  slidesToShow = 1,
  slidesToScroll = 1,
}) => {
  const settings = {
    arrows: showArrows,
    dots: showDots,
    infinite,
    slidesToShow,
    slidesToScroll,
    adaptiveHeight: true,
    // opcional: custom arrows
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Slider {...settings} className="families-gallery">
      {images.map((src, i) => (
        <div key={i} className="families-gallery__slide">
          <img src={src} alt={`slide-${i}`} />
        </div>
      ))}
    </Slider>
  );
};

// Flechas personalizadas opcionales:
const SampleNextArrow = ({ onClick }) => (
  <button className="slick-arrow slick-next" onClick={onClick} />
);
const SamplePrevArrow = ({ onClick }) => (
  <button className="slick-arrow slick-prev" onClick={onClick} />
);

export default ProductImageGallery;
